<div class="list">
    <div class="box" *ngFor="let item of data" (click)="goView(item.url)">
        <img [src]="'/assets/2022/imgs/onlinelook/' + item.cover" alt="" width="391px" height="226px">
        <div class="title">{{item.name}}</div>
        <div class="area">{{item.description}}</div>
        <img src="assets/2022/imgs/onlinelook/list_icon@2x.jpg" alt="" class="bg-list">
    </div>
</div>